// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:09:41

export default {
  "id": "flag-puzzle-jam-collect-flags",
  "slug": "flag-puzzle-jam-collect-flags",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/44f351c4975946469730dfc6dc3dc1ef-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/44f351c4975946469730dfc6dc3dc1ef/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Flag Puzzle Jam: Collect Flags",
      "description": "Immerse yourself in Flag Jam, a unique blend of puzzle-solving, flags collecting, and visual ASMR effects! Tap to match banner pieces, watch them glide smoothly into place, and clear the board as you complete each flag. With easy-to-learn mechanics and stunning visual effects, Flag Jam is the perfect game to help you unwind.",
      "instructions": "The navigation in this is very simple.\nJust use mouse on desktop or your finger tap on mobile devices.",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "flags",
        "logic",
        "matching"
      ]
    },
    "zh-CN": {
      "title": "旗帜拼图挑战赛：收集旗帜",
      "description": "沉浸于《旗牌迷局》，一款结合了解谜、收集旗帜和视觉ASMR效果的独特游戏！轻触匹配旗帜碎片，观看它们平滑地滑入位置，并在完成每面旗帜时清理棋盘。凭借易于学习的机制和惊人的视觉效果，《旗牌迷局》是帮助你放松的完美游戏。",
      "instructions": "本游戏的导航非常简单。\n只需在桌面电脑上使用鼠标，或在移动设备上用手指点击即可。",
      "genres": [
        "拼图"
      ],
      "tags": [
        "旗帜",
        "逻辑",
        "匹配"
      ]
    },
    "zh-TW": {
      "title": "旗幟拼圖狂歡：收集旗幟",
      "description": "沉浸於《旗幟混亂》，一種結合了解謎、收集旗幟和視覺ASMR效果的獨特遊戲！點擊匹配旗幟碎片，欣賞它們順暢地滑入位置，並在完成每面旗幟時清空棋盤。遊戲操作簡單易學，視覺效果壯觀，讓《旗幟混亂》成為幫助你放鬆的完美遊戲。",
      "instructions": "這裡的導航非常簡單。\n只需使用滑鼠在桌上型電腦上或用手指在行動設備上輕觸即可。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "旗幟",
        "邏輯",
        "配對"
      ]
    },
    "zh-HK": {
      "title": "旗子拼圖大賽：收集旗子",
      "description": "投入於《旗子擾攘》，一個結合解謎、收集旗子及視覺ASMR效果的獨特遊戲！輕輕點擊匹配旗幟碎片，欣賞它們順暢滑入位置，並在完成每面旗子時清空棋盤。遊戲機制簡單易學，視覺效果震撼，讓《旗子擾攘》成為幫助你放鬆的完美遊戲。",
      "instructions": "這裡的導航非常簡單。\n只需在桌上型電腦上使用滑鼠或在移動裝置上輕觸手指即可。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "旗子",
        "邏輯",
        "配對"
      ]
    },
    "ja": {
      "title": "旗子パズルジャム：旗を集めろ",
      "description": "旗ジャムに没頭して、パズル解決、旗収集、視覚ASMR効果のユニークなブレンドを楽しみましょう！バナーのピースをタップして一致させ、スムーズに配置されるのを見て、旗を完成させるときにボードをクリアしましょう。簡単に学べるメカニクスと美しい視覚効果で、旗ジャムはリラックスするのに最適なゲームです。",
      "instructions": "このナビゲーションは非常に簡単です。\nデスクトップではマウスを使用し、モバイルデバイスでは指でタップしてください。",
      "genres": [
        "パズル"
      ],
      "tags": [
        "旗印",
        "ロジック",
        "一致"
      ]
    },
    "ko": {
      "title": "기를 모으는 깃발 퍼즐 자메이: 깃발 모으기",
      "description": "Flag Jam, 퍼즐 해결, 기어 수집, 시각적 ASMR 효과가 결합된 독특한 게임에 자신을 잠기세요! 벨트 조각을 매칭하려면 탭하고, 그들이 원활하게 자리를 잡을 것을 지켜보세요. 각기를 완료하면 보드를 클리어하세요. 쉽게 배울 수 있는 기계와 경이로운 시각적 효과로, Flag Jam은 스트레스를 풀기에 완벽한 게임입니다.",
      "instructions": "이 게임의 탐색은 매우 간단합니다.\n데스크톱에서는 마우스를 사용하고, 모바일 장치에서는 손가락으로 탭하세요.",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "기호",
        "논리",
        "매칭"
      ]
    },
    "fr": {
      "title": "Flag Puzzle Jam : Collecte les drapeaux",
      "description": "Immergez-vous dans Flag Jam, une combinaison unique de résolution de puzzles, collecte de drapeaux et d'effets visuels ASMR ! Tappez pour correspondre aux pièces des bannières, regardez-les glisser en douceur à leur place et nettoyez le plateau à mesure que vous terminez chaque drapeau. Avec des mécanismes faciles à apprendre et des effets visuels époustouflants, Flag Jam est le jeu parfait pour vous détendre.",
      "instructions": "La navigation ici est très simple.\nUtilisez simplement la souris sur un ordinateur de bureau ou appuyez avec votre doigt sur les appareils mobiles.",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "drapeaux",
        "logique",
        "correspondance"
      ]
    }
  }
};
